import { successType } from "redux-api-status";
import initialState from "./initialState";
import * as types from "../actions/actionTypes";

export default function bookingsReducer(state = initialState.bookings, action) {
  switch (action.type) {
    case successType(types.LOAD_PERMANENT_VACANCY):
      return {
        ...state,
        PermanentVacancy: action.payload.data,
      };
    case successType(types.LOAD_PERMANENT_VACANCIES):
      return {
        ...state,
        PermanentVacancies: action.payload.data,
      };

    case successType(types.LOAD_BOOKING):
      return {
        ...state,
        Booking: action.payload.data,
        BookingCandidateList: [],
      };

    case successType(types.UPDATE_BOOKING_FILL):
      return {
        ...state,
        Booking: action.payload.data,
      };

    case successType(types.LOAD_BOOKING_CANDIDATELIST):
      const data = action.payload.data;
      if (Array.isArray(data)) {
        return {
          ...state,

          BookingCandidateList: data,
        };
      }

    case successType(types.LOAD_BOOKING_CANDIDATELISTONBOARDING):
      const data2 = action.payload.data;
      if (Array.isArray(data2)) {
        return {
          ...state,
          BookingCandidateListOnboarding: data2.sort((a, b) => {
            const statusA = a.candidatesComplianceStatus.statusOverall;
            const statusB = b.candidatesComplianceStatus.statusOverall;

            if (statusA < statusB) {
              return -1;
            }
            if (statusA > statusB) {
              return 1;
            }
            return 0;
          }),
        };
      }
      // handle case where data is not an array
      return state;

    case successType(types.LOAD_BOOKINGS):
      return {
        ...state,
        Bookings: action.payload.data,
      };
    case successType(types.LOAD_INVOICESDUE):
      return {
        ...state,
        InvoicesDue: action.payload.data,
      };
    case successType(types.LOAD_XEROPAYRUNS):
      return {
        ...state,
        PayRuns: action.payload.data.payRuns.body.payRuns,
      };

    case successType(types.LOAD_PAYROLLDUE):
      return {
        ...state,
        PayrollDue: action.payload.data,
      };
    case successType(types.LOAD_TIMESHEETSDUE):
      return {
        ...state,
        TimesheetsDue: action.payload.data,
      };
    case successType(types.LOAD_JOBROLES):
      return {
        ...state,
        JobRoles: action.payload.data,
      };
    case successType(types.LOAD_CLIENTUSERS_FOR_DROPDOWN):
      return {
        ...state,
        TempContactList: action.payload.data,
      };

    default:
      return state;
  }
}
